<div class="search-dialog-title" mat-dialog-title>Search Options</div>
<mat-dialog-content class="dialog-content p-0 m-0">
  <form class="row m-0 mb-3 pt-3" [formGroup]="paidForm">
    <div class="col-sm-4">
        <mat-select class="filterDropdown" placeholder="Select By" formControlName="searchCategory">
        <ng-container *ngFor="let option of searchCategoryOptions">
          <mat-option [value]="option.value">
            {{option.label}}
          </mat-option>
        </ng-container>
      </mat-select>
    </div>
    <div class="col-sm-8">
      <mat-form-field appearance="outline" [ngClass]="{'input-field w-100': true, 'disabled': paidForm.value.searchCategory === 'searchAll'}">
        <mat-label>Enter {{searchPlaceHolder}}</mat-label>
        <input class="form-control" [readonly]="paidForm.value.searchCategory === 'searchAll'" matInput type="text" formControlName="searchValue"/>
        <mat-hint>Separate each value by ","</mat-hint>
      </mat-form-field>
<!--      <div class="row">-->
<!--        <div class="col-sm-6">-->
      <mat-form-field appearance="outline" class="date-picker w-100">
        <mat-label>Commission Payment Date</mat-label>
        <mat-date-range-input [rangePicker]="picker">
          <input matStartDate placeholder="Start date" formControlName="startDate">
          <input matEndDate placeholder="End date" formControlName="endDate">
        </mat-date-range-input>
        <mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint>
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-date-range-picker #picker></mat-date-range-picker>
      </mat-form-field>
<!--        </div>-->
<!--      </div>-->
    </div>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <div fxLayout="row" fxLayoutAlign="end center" class="w-100">
    <button mat-button mat-raised-button color="primary" [disabled]="paidForm.invalid">Download</button>
    <button mat-button mat-raised-button color="primary" (click)="closeDialog()">Close</button>
  </div>
</mat-dialog-actions>
